import { Dispatch } from 'redux';

import T from '../actionTypes';
import captchaSelector from '../selector';

type ActionPayload = {
  successUrl: string;
  keys: string;
  mountContainer?: string;
  reqTime: number;
};

type InterceptedRequestHandler = {
  reqTime: number;
  resolve: VoidFunction;
  reject: VoidFunction;
};

export const requestHandlers: InterceptedRequestHandler[] = [];

const showCaptcha = ({ successUrl, keys, mountContainer, reqTime }: ActionPayload) => {
  return (dispatch: Dispatch, getState: () => any) => {
    const state = getState();
    const { isCaptchaShown } = captchaSelector(state);

    if (!isCaptchaShown) {
      dispatch({
        type: T.SHOW_CAPTCHA,
        mountContainer,
        successUrl,
        keys,
      });
    }

    return new Promise((resolve, reject) => {
      requestHandlers.push({
        reqTime,
        resolve: resolve as InterceptedRequestHandler['resolve'],
        reject,
      });
    });
  };
};

export default showCaptcha;
